import React, { Component } from 'react';
import {  BrowserRouter as Router, Route } from 'react-router-dom'
import './App.css';

import Menu from "./components/Menu";
import Island from "./components/Island";
import Characters from "./components/Characters";
import Box from "./components/Box";
import Rumors from "./components/Rumors";
import Reports from "./components/Reports";
import Bestiary from "./components/Bestiary";
import Inspiratron from "./components/Inspiratron";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaw, faFile, faQuestion, faDotCircle, faBan, faMap, faUsers, faExclamation, faUserPlus, faMinusCircle, faPlusCircle, faAnchor, faQuestionCircle, faExclamationTriangle, faCertificate, faFire, faTrash, faBoxOpen, faPlus, faGlobeAsia, faComments, faCalendar, faShoppingCart, faCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faPaw, faFile, faQuestion, faDotCircle, faBan, faMap, faUsers, faExclamation, faUserPlus, faMinusCircle, faPlusCircle, faAnchor, faQuestionCircle, faExclamationTriangle, faCertificate, faFire, faTrash, faBoxOpen, faPlus, faGlobeAsia, faComments, faCalendar, faShoppingCart, faCircle)

class App extends Component {
	
	render() {
		return (
		<Router>
			<div className="App">
				<div className="AppTitle">La Marque du Deuil</div>
				<Menu />
				<Route path="/edit/:key" component={Island} />
				<Route exact path="/" component={Island} />
				<Route exact path="/personnages" component={Characters} />
				<Route exact path="/boite" component={Box} />
				<Route exact path="/rumeurs" component={Rumors} />
				<Route exact path="/rapports" component={Reports} />
				<Route exact path="/bestiaire" component={Bestiary} />
				<Route exact path="/inspiratron" component={Inspiratron} />
				
				<Route path="/deuil/edit/:key" component={Island} />
				<Route exact path="/deuil" component={Island} />
				<Route exact path="/deuil/personnages" component={Characters} />
				<Route exact path="/deuil/boite" component={Box} />
				<Route exact path="/deuil/rumeurs" component={Rumors} />
				<Route exact path="/deuil/rapports" component={Reports} />
				<Route exact path="/deuil/bestiaire" component={Bestiary} />
				<Route exact path="/deuil/inspiratron" component={Inspiratron} />
			</div>
		</Router>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js